import fetchExpresso from 'utility/fetchExpresso';

/**
 * Post a notification to the inboxes of our hosts
 * @param {string} title Title of the notification
 * @param {string} url URL of the notification
 * @param {Array | null} hosts Hosts to send the notification to. If null, the notification will be sent to all hosts in the system.
 */
export async function createNotification(title, url, hosts) {
    const response = await fetchExpresso(`/apiv2/admin/notification`, {
        method: 'POST',
        body: {
            title: title,
            url: url,
            hosts: hosts,
        },
    });

    if (response.status === 200) {
        return { success: true };
    } else if (response.status === 400) {
        throw new Error(`[400] Bad request`);
    } else if (response.status === 500) {
        throw new Error(`[500] There was a problem on our end`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}
